<template>

    <div class="gradientBG login-page">
        <div class="container">
            <div class="row justify-content-center">
                <div class="card col-11 col-sm-9 col-md-7 col-lg-5 col-xl-4 rounded-5 shadow-lg border-0 px-3 px-sm-4 py-3 login-card" style="background-color: rgb(255 255 255 / 46%);">
                    <div class="card-body">
                        <div class="text-center"><img src="../assets/rid_logo.png" alt="" class="login-logo"></div>
                        <p class="card-title text-center mt-2 login-title">เข้าสู่ระบบ</p>
                        <div class="text-center login-subtitle">กรุณากรอกข้อมูลเพื่อเข้าสู่ระบบ</div>
                        <form>
                            <div class="mb-3">
                                <label for="exampleInputEmail1" class="form-label"><font-awesome-icon :icon="['fas', 'envelope']"  style="color: gray;"/> Username</label>
                                <input type="text" class="form-control rounded-3" v-model="username"
                                    aria-describedby="emailHelp" style="height: 38px;">

                            </div>
                            <div class="mb-4">
                                <label  class="form-label "><font-awesome-icon :icon="['fas', 'lock']" style="color: gray;"/> Password</label>
                                <input type="password" class="form-control rounded-3" v-model="password" style="height: 38px;">
                            </div>

                        </form>
                        <div class="text-center mt-4"><button @click="login" class="btn btn-primary txte-center rounded-5 login-btn">เข้าสู่ระบบ</button></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'App',
  data() {
    return {
      username: '',
      password: '',
    };
  },
  methods: {
    async login() {
      try {
        const response = await axios.post(`${process.env.VUE_APP_API_URL}/auth/signin`, {
          username: this.username,
          password: this.password
        });
        // ถ้าสำเร็จ
        console.log('Login Success:', response.data);
        // เช่นเก็บ token
        localStorage.setItem('accessToken', response.data.accessToken);
        localStorage.setItem('refreshToken', response.data.refreshToken);
        localStorage.setItem('username', response.data.user.username);
        localStorage.setItem('role', response.data.user.role);
        // ไปหน้าหลัก
        this.$router.push('/');
      } catch (error) {
        console.error('Login failed:', error);
        alert('เข้าสู่ระบบไม่สำเร็จ');
      }
    }
  }
}
</script>

<style scoped>
.gradientBG {
  background: linear-gradient(to right, #7eb7f8bb, #384dc5c0); /* example gradient */
}

/* ✅ Responsive layout — จัดกึ่งกลางทั้งแนวตั้ง/แนวนอนด้วย flexbox แทนการเว้น spacer แบบ fixed px
   กัน card ล้นจอ/เว้นช่องว่างแปลกๆ บนมือถือหรือจอเตี้ย */
.login-page {
  min-height: 100vh;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px 12px;
  box-sizing: border-box;
}

.login-card {
  width: 100%;
  max-width: 420px;
}

.login-card .card-body {
  padding: 8px 4px;
}

.login-logo {
  width: 110px;
  max-width: 100%;
  height: auto;
}

.login-title {
  font-size: clamp(18px, 5vw, 22px);
}

.login-subtitle {
  font-size: clamp(14px, 4vw, 20px);
}

.login-btn {
  width: 100%;
  max-width: 300px;
  font-size: clamp(16px, 4vw, 20px);
}

/* ✅ จอเล็กมาก (มือถือแนวตั้ง) — ลด padding รอบ card ลงอีกหน่อยให้ไม่อึดอัด */
@media (max-width: 380px) {
  .login-page {
    padding: 16px 8px;
  }
  .login-card {
    padding-left: 0.75rem !important;
    padding-right: 0.75rem !important;
  }
}
</style>